
import React from 'react';
import '../styles/Footer.css';
const Footer = () =>{
    return(
        <div>
            < div className="Footer-container">
                <div>
                    <div className="Footer-section">
                    <div className="Footer-title">입시혁명</div> 
                    <div className="Footer-subtitle">
                    개인 정보 처리 방침   ㅣ   이용약관   ㅣ   저작권정책   ㅣ   건의하기</div>
                    </div>
                </div>
                <div className='Line'>
                    <div className='Line1'>
                        <div className="info-text-wrapper">
                            <div className="info-text-1">상호명</div>
                        <   div className="info-text-2">이륙허가</div>
                        </div>
                        <div className="info-text-wrapper">
                            <div className="info-text-1">대표</div>
                            <div className="info-text-2">seol</div>
                        </div>
                        <div className="info-text-wrapper">
                            <div className="info-text-1">사업자등록번호</div>
                            <div className="info-text-2">123-456-789</div>
                        </div>
                        <div className="info-text-wrapper">
                            <div className="info-text-1">위치</div>
                            <div className="info-text-2">경기도 고양시 덕양구 한국항공대학교</div>
                        </div>

                    </div>
                    <div className='Line2'>
                        <div className="info-text-wrapper">
                            <div className="info-text-1">전화번호</div>
                            <div className="info-text-2">010-0000-0000</div>
                        </div>
                        <div className="info-text-wrapper">
                            <div className="info-text-1">개인정보보호책임자</div>
                            <div className="info-text-2">karsa(ballondor7@naver.com)</div>
                        </div>
                        <div className="info-text-wrapper">
                            <div className="info-text-1">임금계좌</div>
                            <div className="info-text-2">123-456-789</div>
                        </div>
                </div>

                </div>
                  <div className="Footer-subtitle2">
                        위 사이트의 모든 서비스들은 멋쟁이 사자처럼 창업 프로젝트이므로 실제로 상품을 판매 및 서비스하지 않으며 연출된 페이지입니다.

                    </div>
                    
             </div>
            
        </div>
        
        
        

    );
};
export default Footer;